import { StyleSheet } from 'aphrodite/no-important';
import constants from '../../../constants/styles';
const { MODAL_TEXT_COLOR } = constants;

let styles = {
  base: {
    width: '100%'
  },
  list: {
    listStyle: 'none',
    padding: 0,
    margin: 0
  },
  item: {
    display: 'flex',
    fontSize: '1.1em',
    borderTop: '1px solid #eee',
    padding: 20,
    cursor: 'pointer',
    ':hover': {
      backgroundColor: '#efefef'
    }
  },
  linear: {
    marginTop: 1,
    marginRight: 10,
    color: MODAL_TEXT_COLOR,
    fontWeight: 'bold',
    fontSize: 18
  },
  svg: {
    marginTop: 1,
    marginRight: 10
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/components/common/addselection/AddSelection.styles.js